export const ENRICH_LIST_REQUEST = "ENRICH_LIST_REQUEST";
export const ENRICH_LIST_SUCCESS = "ENRICH_LIST_SUCCESS";
export const ENRICH_LIST_FAIL = "ENRICH_LIST_FAIL";

export const ENRICH_CONTACTS_REQUEST = "ENRICH_CONTACTS_REQUEST";
export const ENRICH_CONTACTS_SUCCESS = "ENRICH_CONTACTS_SUCCESS";
export const ENRICH_CONTACTS_FAIL = "ENRICH_CONTACTS_FAIL";

export const ENRICH_ORGANIZATIONS_SUCCESS = "ENRICH_ORGANIZATIONS_SUCCESS";
export const ENRICH_ORGANIZATIONS_FAIL = "ENRICH_ORGANIZATIONS_FAIL"; 